import React from 'react';
import classNames from 'classnames';
import './CoachingReviewSelector.styl';
import * as queryParams from 'utils/queryParams';

// TODO: a must be replaced with button and eslint ignore must be removed
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
export default class CoachingReviewSelector extends React.PureComponent {
  render() {
    const {reviews, reviewId, currentlyFillingOutReviewId} = this.props;
    const completedReviews = reviews.filter(r => r.status !== 'SCHEDULED');
    const nextReview = reviews.find(r => r.status === 'SCHEDULED');

    return (
      <div className="coaching-review-selector">
        <div className="finished-reviews">
          {completedReviews
            .push(nextReview)
            .filter(r => !!r)
            .map((review, i) => (
              <a
                href="javascript:"
                className={classNames('coaching-review', {
                  selected: review.id === reviewId,
                })}
                onClick={() => queryParams.set({reviewId: review.id, editFeedback: null}, true)}
                key={review.id}>
                <ReviewText
                  review={review}
                  index={i}
                  currentlyFillingOutReviewId={currentlyFillingOutReviewId}
                />
              </a>
            ))}
        </div>
      </div>
    );
  }
}

function ReviewText({review, index, currentlyFillingOutReviewId}) {
  if (review.id === currentlyFillingOutReviewId) {
    return <span className="current-review">Current Meeting</span>;
  }
  if (index === 0) {
    return <span>Kickoff</span>;
  }
  if (review.status === 'SCHEDULED') {
    return <span className="next-review">Next Meeting</span>;
  }
  return <span>Meeting #{index + 1}</span>;
}
